import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../services/authentication.service';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private auth: AuthenticationService;
    constructor(private config: ConfigService, private injector: Injector) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.config.isConfigLoaded) {
            this.auth = this.injector.get(AuthenticationService);
            const idToken = this.auth.getIdToken();

            // const clonedRequest = req.clone({
            //     headers: req.headers.set('Authorization', `Bearer ${idToken}`)
            // });

            const headers = new HttpHeaders({
                'Authorization': `Bearer ${idToken}`,
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, HEAD, OPTIONS, POST, PUT, DELETE',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
                'Content-Type': 'application/json'
            });

            const clonedRequest = req.clone({ headers });
            return next.handle(clonedRequest);
        }

        return next.handle(req);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/interceptors/auth-interceptor.service.ts